export default {"src":"/_next/static/media/icon-x.25101948.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};